<template>
  <div>
    <div class="formteen" v-if="formteen&&!showXuzhi">
      <!-- 选择报名表单弹窗 -->
      <div class="pagePopMask pFull" @click.self="closePop"></div>
      <div class="pagePop pCenter">
        <div class="w pad60">
          <div class="tit fnt_24">{{ globalDataArray.siteTemplateLanguage.to_sign_up }} <div class="xuzhiBtn" @click="targetXuzhi">{{ globalDataArray.siteTemplateLanguage.join_notice }}</div></div>

          <div class="cont">
            <div class="stform">
              <a-form :form="form" :model="data">
                <a-form-item :label="globalDataArray.siteTemplateLanguage.team_name">
                  <a-input
                    v-decorator="['data.teamName', { rules: [{ required: true, message: globalDataArray.siteTemplateLanguage.enter_join_team }] }]"
                  />
                </a-form-item>

                <a-form-item :label="globalDataArray.siteTemplateLanguage.team_type">
                  <a-radio-group @change="onChange" v-decorator="['data.teamType', { rules: [{ required: true, message: globalDataArray.siteTemplateLanguage.select_team_type }] }]">
                    <span class="radioLabelBox" v-for="(item,index) in teamList" :key="index">
                      <a-radio :style="radioStyle" :value="item.itemValue">{{ item.itemText }}</a-radio>
                      <a-tooltip placement="bottom">
                        <a-icon type="question-circle" title="" />
                        <template slot="title">
                          <span v-html="item.tipsmsg"></span>
                        </template>
                      </a-tooltip>
                    </span>
                  </a-radio-group>
                </a-form-item>

                <div class="item">
                  <a-form-item :label="globalDataArray.siteTemplateLanguage.join_group">
                    <a-select :get-popup-container="triggerNode => { return triggerNode.parentNode || document.body;}" @change="handleGradeChange" v-decorator="['data.groupId', { rules: [{ required: true, message: globalDataArray.siteTemplateLanguage.select_join_group }] }]">
                      <a-select-option v-for="item in groupArray" :key="item.id">
                        {{ item.title }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>

                  <a-form-item :label="globalDataArray.siteTemplateLanguage.join_grade">
                    <a-select :get-popup-container="triggerNode => { return triggerNode.parentNode || document.body;}" v-decorator="['data.grade', { rules: [{ required: true, message: globalDataArray.siteTemplateLanguage.select_join_grade }] }]">
                      <a-select-option v-for="i in groupArraySub" :key="i.id">
                        {{ i.title }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </div>

                <div class="item">
                  <a-form-item :label="globalDataArray.siteTemplateLanguage.leader_name">
                    <a-input
                      v-decorator="['data.leaderName', {rules:[{required:true,message:globalDataArray.siteTemplateLanguage.enter_leader_name}]}]"
                    />
                  </a-form-item>
                  <a-form-item :label="globalDataArray.siteTemplateLanguage.team_user_phone">
                    <a-input
                      v-decorator="['data.userPhone',{rules:[{pattern:/^[0-9-+]+$/,message: globalDataArray.siteTemplateLanguage.tel_format_error},{required:true,message:globalDataArray.siteTemplateLanguage.enter_member_tel}]}]"
                    />
                  </a-form-item>
                </div>

                <div class="item">
                  <a-form-item :label="globalDataArray.siteTemplateLanguage.team_user_email">
                    <a-input
                      v-decorator="['data.userMail',{ rules:[{ validator: validateNumber, trigger: 'blur'},{required:true,message:globalDataArray.siteTemplateLanguage.person_please_form_user_email}]}]"
                    />
                  </a-form-item>
                </div>
                <div class="line"></div>

                <div class="item">
                  <a-form-item :label="globalDataArray.siteTemplateLanguage.name_text">
                    <a-input
                      v-decorator="['data.userName', {rules:[{required:true,message:globalDataArray.siteTemplateLanguage.enter_name_text}]}]"
                    />
                  </a-form-item>

                  <a-form-item :label="globalDataArray.siteTemplateLanguage.team_member_school">
                    <a-input
                      v-decorator="['data.company',{ rules:[{required:true,message:globalDataArray.siteTemplateLanguage.person_please_form_school_name}]}]"
                    />
                  </a-form-item>
                </div>

                <div class="item">
                  <a-form-item :label="globalDataArray.siteTemplateLanguage.person_form_province">
                    <!-- <a-cascader :options="cityList" :defaultValue="defaultArea" placeholder="Please select" @change="onChange" /> -->
                    <a-select :get-popup-container="triggerNode => { return triggerNode.parentNode || document.body;}" @change="handleProvinceChange($event,'-1')" :label-in-value="true" v-decorator="['data.countryCode', { rules: [{ required: true, message: globalDataArray.siteTemplateLanguage.person_please_form_province }] }]">
                      <a-select-option v-for="item in provinceList" :key="item.parentId">
                        {{ item.title }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>

                  <a-form-item :label="globalDataArray.siteTemplateLanguage.team_user_city">
                    <a-select :get-popup-container="triggerNode => { return triggerNode.parentNode || document.body;}" :label-in-value="true" v-decorator="['data.cityCode']">
                      <a-select-option v-for="i in data.cityList" :key="i.parentId">
                        {{ i.title }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </div>

                <!-- 增减团队成员模板 start -->
                <div class="addPrsonTemp" v-for="(k) in form.getFieldValue('keys')" :key="k">
                  <div class="line"></div>
                  <div class="item">
                    <a-form-item :label="globalDataArray.siteTemplateLanguage.name_text">
                      <a-input
                        v-decorator="[`temp[${k}].userName`, {rules:[{required:true,message:globalDataArray.siteTemplateLanguage.enter_name_text}]}]"
                      />
                    </a-form-item>
                    <a-form-item :label="globalDataArray.siteTemplateLanguage.team_member_school">
                      <a-input
                        v-decorator="[`temp[${k}].company`,{ rules:[{required:true,message:globalDataArray.siteTemplateLanguage.person_please_form_school_name}]}]"
                      />
                    </a-form-item>
                  </div>

                  <div class="item">
                    <a-form-item :label="globalDataArray.siteTemplateLanguage.person_form_province">
                      <a-select :get-popup-container="triggerNode => { return triggerNode.parentNode || document.body;}" @change="handleProvinceChange($event,k)" :label-in-value="true" v-decorator="[`temp[${k}].countryCode`, { rules: [{ required: true, message: globalDataArray.siteTemplateLanguage.person_please_form_province }] }]">
                        <a-select-option v-for="prov in provinceList" :key="prov.parentId">
                          {{ prov.title }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>

                    <a-form-item :label="globalDataArray.siteTemplateLanguage.team_user_city">
                      <a-select :get-popup-container="triggerNode => { return triggerNode.parentNode || document.body;}" :label-in-value="true" v-decorator="[`temp[${k}].cityCode`]">
                        <a-select-option v-for="city in temp[k].cityList" :key="city.parentId">
                          {{ city.title }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </div>

                  <a-button @click="delPerson(k)"> <a-icon type="minus" /> {{ globalDataArray.siteTemplateLanguage.del_team_member }} </a-button>
                </div>

                <a-button @click="addPerson()"> <a-icon type="plus" /> {{ globalDataArray.siteTemplateLanguage.add_team_member }} </a-button>
              <!-- 增减团队成员模板 end -->
              </a-form>
            </div>
          </div>

          <div class="btnBox fnt_18">
            <div class="btn btn1" @click="btnClick('1')">{{ globalDataArray.siteTemplateLanguage.right_away_sign }}</div>
            <div class="btn btn2" @click="btnClick('2')">{{ globalDataArray.siteTemplateLanguage.cancel }}</div>
          </div>

          <div class="close" @click.self="closePop"></div>
        </div>
      </div>
    </div>

    <div class="pagePopMask pFull" v-if="showXuzhi" @click="targetXuzhi"></div>
    <div class="pagePop pCenter" v-if="showXuzhi">
      <div class="w pad60">
        <div class="tit fnt_32">{{ xuzhiCont.title }}</div>

        <div class="cont" v-html="xuzhiCont.content">
        </div>
        <div class="btnBox fnt_18">
          <div class="btn btn1" @click="targetXuzhi">{{ globalDataArray.siteTemplateLanguage.verify }}</div>
        </div>
        <div class="close" @click="targetXuzhi"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { message } from 'ant-design-vue'
import { getCompetitionDict, getProvinceList, getCityList, getArticle, getArticleDetail } from '@/api/api'
import { competitionSub, getGroupList } from '@/api/saiti'

let id = 0
export default {
  name: 'Formteen',
  props: {
    formteen: {
      type: Boolean,
      default: false
    },
    curInfoArray: {
      type: Object,
      default: () => ({})
    },
    competitionId: {
      type: String,
      default: ''
    },
    inviteId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      subSignInfo: true,
      data: {
        teamName: '',
        teamType: '',
        leaderName: '',
        userName: '',
        userPhone: '',
        userMail: '',
        companyType: '',
        company: '',
        jobType: '',
        countryCode: '',
        countryName: '',
        cityCode: '',
        cityName: '',
        cityList: [],
        groupId: '',
        grade: ''
      },

      temp: [], // 添加的队员数据模板

      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px'
      },

      provinceList: {}, // 公共的省或国家
      teamList: {}, // 公共的团队类型
      groupArray: {}, // 年级组别
      groupArraySub: {}, // 年级组别下级

      tipsMsg: {}, // 个人参赛说明/////组织机构参赛说明

      xuzhiCont: '',
      showXuzhi: false
    }
  },

  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'dynamic_form_item' })
    this.form.getFieldDecorator('keys', { initialValue: [], preserve: true })
  },
  mounted() {

  },
  watch: {
    formteen: {
      immediate: true,
      handler(val) {
        if (val) {
          const that = this
          that.temp = []
          this.subSignInfo = true
          this.xuzhiCont = ''
          id = 0
          this.form.resetFields()

          that.initDictFun()
        }
      }
    }
  },
  methods: {
    initDictFun() {
      const that = this
      const params = 'dictCode=competition_signup_team_type'
      getCompetitionDict(params).then(res => {
        if (res.success) {
          // console.log(res)
          res.result.forEach((item, index) => {
            if (item.dictCode == 'competition_signup_team_type') { // 团队类型
              // that.teamList=item.list        //公共的团队类型

              const teamList = item.list
              // 两个说明
              getArticle('type=5,6').then(res => {
                if (res.success) {
                  const tipsMsg = res.result

                  teamList.forEach((item, index) => {
                    if (item.itemValue == '01') { // 个人
                      tipsMsg.forEach((e, i) => {
                        if (e.type == '5') {
                          item['tipsmsg'] = e.content
                        }
                      })
                    }

                    if (item.itemValue == '02') { // 公司
                      tipsMsg.forEach((e, i) => {
                        if (e.type == '6') {
                          item['tipsmsg'] = e.content
                        }
                      })
                    }
                  })

                  that.teamList = teamList
                }
              })
            }
          })
        }
      })

      getProvinceList().then(res => {
        if (res.success) {
          that.provinceList = res.result // 省或国家列表
        }
      })

      getGroupList().then(res => {
        if (res.success) {
          that.groupArray = res.result // 参赛组别年级列表
        }
      })
    },

    onChange(e) {
      // console.log(e.target.value)
    },

    addPerson() {
      const temp = this.temp
      const curInfoArray = this.curInfoArray
      const data = this.data
      const max_member_num = this.globalDataArray.siteTemplateLanguage.max_member_num

      const { form } = this
      // can use data-binding to get
      const keys = form.getFieldValue('keys')
      if (keys.length == curInfoArray.teamsUsers - 1) {
        message.error(max_member_num + curInfoArray.teamsUsers)
        return false
      }

      temp.push(data)

      const nextKeys = keys.concat(id++)

      // can use data-binding to set
      // important! notify form to detect changes
      form.setFieldsValue({
        keys: nextKeys
      })
    },
    delPerson(k) {
      // this.temp.splice(k,1)

      const { form } = this
      // can use data-binding to get
      const keys = form.getFieldValue('keys')

      // can use data-binding to set
      form.setFieldsValue({
        keys: keys.filter(key => key !== k)
      })
    },

    // 省市联动
    handleProvinceChange(e, ind) {
      // console.log(e,ind)
      const that = this
      const params = 'pid=' + e.key
      getCityList(params).then(res => {
        if (res.success) {
          if (ind == -1) {
            that.data.cityList = res.result
            setTimeout(() => {
              // 选择后清空二级
              this.form.setFieldsValue({
                'data.cityCode': ''
              })
            })
          } else {
            that.temp[ind].cityList = res.result
            setTimeout(() => {
              // 选择后清空二级
              this.form.setFieldsValue({
                [`temp[${ind}].cityCode`]: ''
              })
            })
          }
        }
      })
    },

    // 年级
    handleGradeChange(e) {
      // console.log(e)
      const that = this
      that.groupArray.forEach((item, index) => {
        if (item.id == e) {
          that.groupArraySub = item.sub
          setTimeout(() => {
            // 选择后清空二级
            this.form.setFieldsValue({
              'data.grade': ''
            })
          })
        }
      })
    },

    btnClick(num) {
      if (num == 1) { // 报名
        if (this.subSignInfo) {
          const sourceParam = (window.localStorage.getItem('competition-utm-source') || '').trim()

          this.form.validateFields((err, val) => {
            const params = []
            const curInfoArray = this.curInfoArray
            Object.keys(curInfoArray).forEach(key => {
              val.data[key] = curInfoArray[key]
            })
            val.data['isCaptain'] = 1

            if (val.data.countryCode != '' && val.data.countryCode != undefined) {
              const countryKL = val.data.countryCode
              val.data['countryCode'] = countryKL.key
              val.data['countryName'] = countryKL.label
            }

            if (val.data.cityCode != '' && val.data.cityCode != undefined) {
              const cityKL = val.data.cityCode
              val.data['cityCode'] = cityKL.key
              val.data['cityName'] = cityKL.label
            } else {
              val.data['cityCode'] = ''
              val.data['cityName'] = ''
            }

            if (sourceParam) {
              val.data['inviteCode'] = sourceParam
            }

            if (this.inviteId) {
              val.data['inviteId'] = this.inviteId
            }

            params.push(val.data)

            if (val.temp) {
              const validMembers = val.temp.filter(item => this.shouldKeepMember(item))
              validMembers.forEach((item, index) => {
                Object.keys(curInfoArray).forEach(key => {
                  item[key] = curInfoArray[key]
                })
                item['isCaptain'] = 0

                if (item.countryCode != '' && item.countryCode != undefined) {
                  const countryKL = item.countryCode
                  item['countryCode'] = countryKL.key
                  item['countryName'] = countryKL.label
                }

                if (item.cityCode != '' && item.cityCode != undefined) {
                  const cityKL = item.cityCode
                  item['cityCode'] = cityKL.key
                  item['cityName'] = cityKL.label
                } else {
                  item['cityCode'] = ''
                  item['cityName'] = ''
                }

                item['teamName'] = val.data['teamName']
                item['teamType'] = val.data['teamType']
                item['leaderName'] = val.data['leaderName']
                item['grade'] = val.data['grade']
                item['groupId'] = val.data['groupId']

                if (sourceParam) {
                  item['inviteCode'] = sourceParam
                }

                params.push(item)
              })
            }

            // console.log(params)
            if (!err) {
              this.subSignInfo = false
              competitionSub(params).then(res => {
                this.subSignInfo = true
                // console.log(res)
                if (res.success) {
                  this.$emit('itemclick', num) // itemclick  为事件名
                  this.$emit('update:formteen', false)
                  if (window._oafs) {
                    window._oafs.action('报名成功', {
                      comId: params[0].competitionId
                    })
                  }
                } else {
                  if (res.code == '403') {
                    message.error(res.message)
                  }
                }
              })
            }
          })
        }
      } else {
        // 自定义事件，把num传给父组件,发射事件
        this.$emit('itemclick', num) // itemclick  为事件名
        this.$emit('update:formteen', false)
      }
    },

    closePop() {
      this.$emit('update:formteen', false)
    },
    shouldKeepMember(member) {
      if (!member) {
        return false
      }
      const fields = ['userName', 'userPhone', 'userMail', 'memberId']
      return fields.some(field => {
        const value = member[field]
        if (typeof value === 'string') {
          return value.trim() !== ''
        }
        return value !== undefined && value !== null
      })
    },

    targetXuzhi() {
      this.showXuzhi = !this.showXuzhi
      if (this.showXuzhi && this.xuzhiCont == '') {
        const params = 'id=1705132838718054401'
        getArticleDetail(params).then(res => {
          if (res.success) {
            this.xuzhiCont = res.result
          }
        })
      }
    },

    validateNumber(rule, value, callback) {
      const regMail = new RegExp('^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}(\.[a-zA-Z]{2,6})?)$')
      if (value != '' && value != undefined && !regMail.test(value)) {
        callback(new Error(this.globalDataArray.siteTemplateLanguage.mail_format_error))
      } else {
        callback()
      }
    }
  }
}
</script>
